var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1634 1.11914H5.83691V8.89391H10.1634V1.11914Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11158 5.00702C6.1109 4.25826 6.28057 3.51915 6.60776 2.84566C6.93495 2.17216 7.41108 1.58192 8.0001 1.11964C7.27068 0.546301 6.39467 0.189749 5.47219 0.0907391C4.54971 -0.00827121 3.61799 0.154255 2.78352 0.559741C1.94904 0.965227 1.24548 1.59731 0.753254 2.38375C0.26103 3.17019 0 4.07925 0 5.00702C0 5.9348 0.26103 6.84386 0.753254 7.6303C1.24548 8.41674 1.94904 9.04882 2.78352 9.45431C3.61799 9.8598 4.54971 10.0223 5.47219 9.92331C6.39467 9.8243 7.27068 9.46775 8.0001 8.89441C7.41108 8.43212 6.93496 7.84189 6.60777 7.1684C6.28058 6.4949 6.1109 5.75579 6.11158 5.00702Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 5.00702C15.9999 5.93478 15.7389 6.84384 15.2467 7.63028C14.7545 8.41672 14.051 9.04881 13.2165 9.4543C12.382 9.85979 11.4503 10.0223 10.5279 9.92331C9.6054 9.8243 8.7294 9.46775 8 8.89441C8.5885 8.43166 9.06426 7.84133 9.39139 7.16794C9.71853 6.49455 9.8885 5.75567 9.8885 5.00702C9.8885 4.25837 9.71853 3.5195 9.39139 2.84611C9.06426 2.17272 8.5885 1.58239 8 1.11964C8.7294 0.546299 9.6054 0.189747 10.5279 0.0907383C11.4503 -0.00827088 12.382 0.154258 13.2165 0.559749C14.051 0.965239 14.7545 1.59733 15.2467 2.38377C15.7389 3.1702 15.9999 4.07926 15.9998 5.00702Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5285 8.07082V7.91165H15.5927V7.87922H15.4292V7.91165H15.4934V8.07082H15.5285ZM15.8458 8.07082V7.87891H15.7957L15.7381 8.01091L15.6804 7.87891H15.6303V8.07082H15.6657V7.92606L15.7197 8.05087H15.7564L15.8105 7.92574V8.07082H15.8458Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.e9e8a624e19ab6df2a3643e519426682.svg";
export { ForwardRef as ReactComponent };